import { TokenBalance } from '~/components/component-library'
import { IAddress } from '~/types'

type SlippageTooltipContentProps = {
  variant: 'max-spend' | 'min-receive'
  tokenAddress: IAddress
  chainId: number
  amount: bigint
}

const COPY: Record<SlippageTooltipContentProps['variant'], string> = {
  'max-spend': 'You will spend at most ',
  'min-receive': 'You will receive at least ',
}

export const SlippageTooltipContent = ({
  variant,
  tokenAddress,
  chainId,
  amount,
}: SlippageTooltipContentProps) => (
  <div className="flex flex-col gap-2 pb-1 pt-1 text-xs">
    <p>
      {COPY[variant]}
      <TokenBalance
        address={tokenAddress}
        chainId={chainId}
        tokenAmount={amount}
        direction="neutral"
        layout="inline"
        size="base"
      />
    </p>
  </div>
)
